module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('BaseBaseAccess'), (_vm.props.app.information) ? _c('Navigation', {
    attrs: {
      "props": _vm.props.app.information.acf
    }
  }) : _vm._e(), _c('router-view'), (_vm.props.app.information) ? _c('Footer', {
    attrs: {
      "props": _vm.props.app.information.acf
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [_c('Modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.showModal),
      expression: "$store.state.showModal"
    }]
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-273bc00e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/base/app.pug
// module id = 559
// module chunks = 1